var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "awards" },
    [
      _c("div", { staticClass: "head" }, [
        _c("ul", [
          _c(
            "li",
            [
              _c("h5", [_vm._v("上下线")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.line,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "line", $$v)
                    },
                    expression: "form.line",
                  },
                },
                _vm._l(_vm.lines, function (item) {
                  return _c("el-option", {
                    key: item.line,
                    attrs: { label: item.label, value: item.line },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.empty } },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/home/award/add",
                  expression: "'/home/award/add'",
                },
              ],
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "30px" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "序号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.isShow == scope.row.id
                      ? _c("el-input", {
                          directives: [{ name: "focus", rawName: "v-focus" }],
                          attrs: {
                            type: "text",
                            autofocus: true,
                            maxlength: "9",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.bindSeq(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.seq,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "seq", $$v)
                            },
                            expression: "scope.row.seq",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow != scope.row.id,
                            expression: "isShow  != scope.row.id",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeSeq(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.seq))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "图片标题CN",
              "show-overflow-tooltip": "",
              prop: "nameCn",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "图片描述CN",
              "show-overflow-tooltip": "",
              prop: "descriptionCn",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "颁奖机构CN",
              "show-overflow-tooltip": "",
              prop: "mechanismCn",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "上线/下线",
              prop: "line",
              formatter: _vm.lineFormatter,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作人", prop: "updateUser" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作时间", prop: "updateTime" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "function-icon" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/award/update",
                                expression: "'/home/award/update'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "修改",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/amend.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.change(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/award/delete",
                                expression: "'/home/award/delete'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "删除",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/delete.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dele(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/award/online",
                                expression: "'/home/award/online'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "上线",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/online.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.online(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/home/award/unline",
                                expression: "'/home/award/unline'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "下线",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/offline.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.offline(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "预览",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/view.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.preview(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              "page-size": 10,
              total: _vm.total,
              "current-page": _vm.currentPage,
            },
            on: { "current-change": _vm.changepage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增",
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: function ($event) {
              return _vm.addClose("addform")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addform",
              attrs: {
                model: _vm.addform,
                rules: _vm.rules,
                "status-icon": true,
                "show-message": false,
                "hide-required-asterisk": "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "序号", "label-width": _vm.formLabelWidth } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", maxlength: "9" },
                    model: {
                      value: _vm.addform.seq,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "seq", $$v)
                      },
                      expression: "addform.seq",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题（CN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "nameCn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.nameCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "nameCn", $$v)
                      },
                      expression: "addform.nameCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题（EN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "nameEn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.nameEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "nameEn", $$v)
                      },
                      expression: "addform.nameEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题（JA）",
                    "label-width": _vm.formLabelWidth,
                    prop: "nameJa",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.nameJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "nameJa", $$v)
                      },
                      expression: "addform.nameJa",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述（CN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "descriptionCn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.descriptionCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "descriptionCn", $$v)
                      },
                      expression: "addform.descriptionCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述（EN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "descriptionEn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.descriptionEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "descriptionEn", $$v)
                      },
                      expression: "addform.descriptionEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述（JA）",
                    "label-width": _vm.formLabelWidth,
                    prop: "descriptionJa",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.descriptionJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "descriptionJa", $$v)
                      },
                      expression: "addform.descriptionJa",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片CN(1920*720)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture1,
                          },
                        },
                        [
                          _vm.imageUrl1
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl1 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端图片CN(550*324)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture2,
                          },
                        },
                        [
                          _vm.imageUrl2
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl2 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片EN(1920*720)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture3,
                          },
                        },
                        [
                          _vm.imageUrl3
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl3 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端图片EN(550*324)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture4,
                          },
                        },
                        [
                          _vm.imageUrl4
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl4 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片JA(1920*720)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture5,
                          },
                        },
                        [
                          _vm.imageUrl5
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl5 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端图片JA(550*324)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture6,
                          },
                        },
                        [
                          _vm.imageUrl6
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl6 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "荣誉链接（CN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "500",
                    },
                    model: {
                      value: _vm.addform.linkCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "linkCn", $$v)
                      },
                      expression: "addform.linkCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "荣誉链接（EN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "500",
                    },
                    model: {
                      value: _vm.addform.linkEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "linkEn", $$v)
                      },
                      expression: "addform.linkEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "荣誉链接（JA）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "500",
                    },
                    model: {
                      value: _vm.addform.linkJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "linkJa", $$v)
                      },
                      expression: "addform.linkJa",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "颁奖机构（CN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.mechanismCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "mechanismCn", $$v)
                      },
                      expression: "addform.mechanismCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "颁奖机构（EN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.mechanismEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "mechanismEn", $$v)
                      },
                      expression: "addform.mechanismEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "颁奖机构（JA）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.mechanismJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "mechanismJa", $$v)
                      },
                      expression: "addform.mechanismJa",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addClose("addform")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.sure("addform")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改",
            visible: _vm.dialogFormVisible2,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible2 = $event
            },
            close: function ($event) {
              return _vm.changeClose("addform")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addform",
              attrs: {
                model: _vm.addform,
                rules: _vm.rules,
                "status-icon": true,
                "show-message": false,
                "hide-required-asterisk": "",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题（CN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "nameCn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.nameCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "nameCn", $$v)
                      },
                      expression: "addform.nameCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题（EN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "nameEn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.nameEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "nameEn", $$v)
                      },
                      expression: "addform.nameEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题（JA）",
                    "label-width": _vm.formLabelWidth,
                    prop: "nameJa",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.nameJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "nameJa", $$v)
                      },
                      expression: "addform.nameJa",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述（CN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "descriptionCn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.descriptionCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "descriptionCn", $$v)
                      },
                      expression: "addform.descriptionCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述（EN）",
                    "label-width": _vm.formLabelWidth,
                    prop: "descriptionEn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.descriptionEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "descriptionEn", $$v)
                      },
                      expression: "addform.descriptionEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "描述（JA）",
                    "label-width": _vm.formLabelWidth,
                    prop: "descriptionJa",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.descriptionJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "descriptionJa", $$v)
                      },
                      expression: "addform.descriptionJa",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片CN(1920*720)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture1,
                          },
                        },
                        [
                          _vm.imageUrl1
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl1 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端图片CN(550*324)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture2,
                          },
                        },
                        [
                          _vm.imageUrl2
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl2 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片EN(1920*720)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture3,
                          },
                        },
                        [
                          _vm.imageUrl3
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl3 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端图片EN(550*324)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture4,
                          },
                        },
                        [
                          _vm.imageUrl4
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl4 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "commont" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "pc图片JA(1920*720)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture5,
                          },
                        },
                        [
                          _vm.imageUrl5
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl5 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移动端图片JA(550*324)",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          attrs: {
                            action:
                              "https://jsonplaceholder.typicode.com/posts/",
                            "show-file-list": false,
                            "before-upload": _vm.beforeUploadPicture6,
                          },
                        },
                        [
                          _vm.imageUrl6
                            ? _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.imageUrl6 },
                              })
                            : _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "荣誉链接（CN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "500",
                    },
                    model: {
                      value: _vm.addform.linkCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "linkCn", $$v)
                      },
                      expression: "addform.linkCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "荣誉链接（EN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "500",
                    },
                    model: {
                      value: _vm.addform.linkEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "linkEn", $$v)
                      },
                      expression: "addform.linkEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "荣誉链接（JA）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "500",
                    },
                    model: {
                      value: _vm.addform.linkJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "linkJa", $$v)
                      },
                      expression: "addform.linkJa",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "颁奖机构（CN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.mechanismCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "mechanismCn", $$v)
                      },
                      expression: "addform.mechanismCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "颁奖机构（EN）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.mechanismEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "mechanismEn", $$v)
                      },
                      expression: "addform.mechanismEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "颁奖机构（JA）",
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      type: "text",
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.addform.mechanismJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "mechanismJa", $$v)
                      },
                      expression: "addform.mechanismJa",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeClose("addform")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.keep("addform")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }